import request from '@/utils/request'

export function getViolationList(params) {
    return request({
        url: '/api/Violation/ListByUser',
        data: { ...params },
        method: 'post',
        header: {
            'Content-Type': 'application/json;charset=utf-8'  //如果写成contentType会报错
        },

    })
}


export function getViolationCount(params) {
    return request({
        url: '/api/Violation/GetViolationCount',
        data: { ...params },
        method: 'post',
        header: {
            'Content-Type': 'application/json;charset=utf-8'  //如果写成contentType会报错
        },

    })
}